import React from 'react';
import { useIntl } from 'react-intl';
import classNames, { Argument } from 'classnames';

import useCurrentStep from 'hooks/useCurrentStep';

import Icon from '../Icon';
import HelpModal from './Modal';
import Button, { ButtonType } from '../Button';

type HelpButtonProps = {
  className?: Argument;
  wrapperClassName?: Argument;
};

const HelpButton: React.FC<HelpButtonProps> = ({ className, wrapperClassName }) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = React.useState(false);
  const currentStep = useCurrentStep();

  const handleOpenModal = () => setIsOpen(true);
  const handleCloseModal = () => setIsOpen(false);

  return (
    <div className={classNames('py-3 kiosk:py-10 z-50', wrapperClassName)}>
      <Button
        className={classNames('size-10 kiosk:size-20 p-0! kiosk:p-2! flex items-center justify-center btn-header', className)}
        aria-label={intl.formatMessage({ id: 'helpLine.title', defaultMessage: 'Need help ?' })}
        onClick={handleOpenModal}
        type={ButtonType.ICON}
        testId="help-button"
        analytics={{
          category: 'Help',
          action: 'Help button',
          label: `Help needed from ${currentStep}`,
        }}
      >
        <Icon className="text-btn-header-help-icon fb-icon--question text-4xl kiosk:text-6xl" />
      </Button>
      <HelpModal open={isOpen} onClose={handleCloseModal} />
    </div>
  );
};

export default HelpButton;
